import {SiteSettings, SiteSettingsSettings} from '../../../../commons/types/state'
import {createAsyncAction} from '../services/redux-toolkit'

export const updateSiteSettings = createAsyncAction<{settings: SiteSettings}, Partial<SiteSettingsSettings>>(
  'UPDATE_SITE_SETTINGS',
  async (payload, {extra: {serverApi}, getState}) => {
    const settings = {...getState().siteSettings.settings, ...payload}

    return serverApi.updateSiteSettings(settings)
  },
)
